import type {ReferenceTypes} from '@github-ui/timeline-items'
import type {TimelineItemsPaginated$data} from '../components/__generated__/TimelineItemsPaginated.graphql'

type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends ReadonlyArray<infer ElementType>
  ? ElementType
  : never

export type TimelineItem = NonNullable<ArrayElement<NonNullable<TimelineItemsPaginated$data['edges']>>>['node']

type GroupedEventsData = {
  numEvents: number
  referenceTypes?: ReferenceTypes
}

const emptyGroupedEventsData: GroupedEventsData = {
  numEvents: 0,
}

export function getNumNextSameEvents(
  currentType: string,
  timelineItems: TimelineItem[],
  index: number,
): GroupedEventsData {
  const currentActor = timelineItems[index]?.actor?.login
  if (!currentActor) {
    return emptyGroupedEventsData
  }
  if (currentType !== 'CrossReferencedEvent' && currentType !== 'ReferencedEvent') {
    return emptyGroupedEventsData
  }
  if (currentType === 'CrossReferencedEvent' && timelineItems[index]?.willCloseTarget === true) {
    return emptyGroupedEventsData
  }

  let numNextSameEvents = 0

  const sourceTypes: string[] = []
  const firstSourceType = timelineItems[index]?.source?.__typename
  if (firstSourceType) {
    sourceTypes.push(firstSourceType)
  }

  for (let i = index + 1; i < timelineItems.length; i++) {
    if (
      timelineItems[i]?.__typename !== currentType ||
      timelineItems[i]?.actor?.login !== currentActor ||
      timelineItems[i]?.willCloseTarget === true
    ) {
      break
    }
    const sourceType = timelineItems[i]?.source?.__typename
    if (sourceType) {
      sourceTypes.push(sourceType)
    }
    numNextSameEvents++
  }

  return {
    numEvents: numNextSameEvents,
    referenceTypes: getReferenceTypes(sourceTypes),
  }
}

function getReferenceTypes(sourceTypes: string[]): ReferenceTypes | undefined {
  if (sourceTypes.length === 0) {
    return undefined
  }
  const uniqueSourceTypes = new Set(sourceTypes)
  if (uniqueSourceTypes.size > 1) {
    return 'mixed'
  }

  if (uniqueSourceTypes.values().next().value === 'PullRequest') {
    return 'prs'
  } else if (uniqueSourceTypes.values().next().value === 'Issue') {
    return 'issues'
  }

  return undefined
}
